import { baseTrafficLightConfig, TrafficLightConfigType } from '@pp/core';

const TrafficLightExtension: Record<string, TrafficLightConfigType> = {
  SPINNING: {
    label: 'SPINNING_CAPS',
    rendersTimer: false,
    style: 'mw_default',
  },
  MEGA_WIN: {
    label: 'MEGAWIN_CAPS',
    rendersTimer: false,
    style: 'mw',
    color: 'default',
  },
  YOU_WIN: {
    label: 'YOU_WIN',
    rendersTimer: false,
    style: 'yw',
    color: 'default',
  },
  MEGA_MULTIPLIER: {
    label: 'MEGAWHEEL_MEGA_MULT_CAPS',
    rendersTimer: false,
    style: 'multiplier',
    color: 'multiplier',
  },
  RESULT_1: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['1'],
    rendersTimer: false,
    style: 'mw_1',
    color: 'mw_1',
  },
  RESULT_2: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['2'],
    rendersTimer: false,
    style: 'mw_2',
    color: 'default',
  },
  RESULT_5: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['5'],
    rendersTimer: false,
    style: 'mw_5',
    color: 'default',
  },
  RESULT_8: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['8'],
    rendersTimer: false,
    style: 'mw_8',
    color: 'default',
  },
  RESULT_10: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['10'],
    rendersTimer: false,
    style: 'mw_10',
    color: 'default',
  },
  RESULT_15: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['15'],
    rendersTimer: false,
    style: 'mw_15',
    color: 'default',
  },
  RESULT_20: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['20'],
    rendersTimer: false,
    style: 'mw_20',
    color: 'default',
  },
  RESULT_30: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['30'],
    rendersTimer: false,
    style: 'mw_30',
    color: 'default',
  },
  RESULT_40: {
    label: 'RESULT_WITH_VALUE',
    attrs: ['40'],
    rendersTimer: false,
    style: 'mw_40',
    color: 'mw_40',
  },
  WAITFORNEXTGAME: {
    label: 'WAITFORNEXTGAME',
    rendersTimer: false,
    style: 'mw_default',
  },
  BETSCLOSED: {
    label: 'BETS_CLOSED',
    rendersTimer: false,
    style: 'mw_default',
  },
};

export const MegaWheelTrafficLightConfig: Record<string, TrafficLightConfigType> = {
  ...baseTrafficLightConfig,
  ...TrafficLightExtension,
};
